import { ApiNotFoundComponentModule } from "./../../_component/api-not-found/api-not-found.component.module";
import { BreadcrumbComponentModule } from "./../../_component/breadcrumb/breadcrumb.module";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { EditorModule } from "@tinymce/tinymce-angular";
import { SelectDropdownModule } from "src/app/app/_component/select-dropdown/select-dropdown.module";
import { UploadAttachmentModule } from "src/app/app/_component/upload-attachment/upload-attachment.module";
import { HeaderModule } from "src/app/_component/header/header.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { EditCommunityPageRoutingModule } from "./edit-community-routing.module";
import { EditCommunityPage } from "./edit-community.page";
import { CardComponentModule } from "../../_component/_structural/card/card.module";
import { DateTimePickerComponentModule } from "../../_component/date-time-picker/date-time-picker.module";
import { InputsModule } from "src/app/_component/inputs/inputs.module";
import { CommunityDescriptionAiComponent } from "../community-description-ai/community-description-ai.component";
import { ModalHeaderComponentModule } from "../../_component/modal-header/modal-header.module";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    EditCommunityPageRoutingModule,
    HeaderModule,
    TranslateModule,
    UploadAttachmentModule,
    SelectDropdownModule,
    LoadingStiModule,
    EditorModule,
    SharedDirectivesModule,
    BreadcrumbComponentModule,
    CardComponentModule,
    DateTimePickerComponentModule,
    ApiNotFoundComponentModule,
    InputsModule,
    ModalHeaderComponentModule,
  ],
  declarations: [
    EditCommunityPage,
    CommunityDescriptionAiComponent,
  ],
  exports: [
    CommunityDescriptionAiComponent,
  ],
})
export class EditCommunityPageModule {}
